import { createAction, props } from '@ngrx/store';

export const ALL = '[UserProifile] All';
export const USER_PROFILE_ID = '[UserProifileId] UserProfileId';

export const UserProfileIdAction = createAction(
  USER_PROFILE_ID,
  props<{
    userProfileId: number;
  }>()
);

export const AllAction = createAction(
  ALL,
  props<{
    name: string;
    userProfileId: number;
  }>()
);

export type All = ReturnType<typeof AllAction>
  | ReturnType<typeof UserProfileIdAction>;
